import { Column, Entity, Index, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { ChapterWiseModel } from "../model-paper/entities/chapter-wise-model.entity";

@Index("class", ["class"], {})
@Index("subject", ["subject"], {})
@Index("estatus", ["estatus"], {})
@Entity("chapter")
export class Chapter {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "class", length: 50, default: () => "''" })
  class: string;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("text", { name: "chapter" })
  chapter: string;

  @Column("varchar", { name: "estatus", length: 2, default: () => "'1'" })
  estatus: string;

  @Column("varchar", { name: "timestamp", length: 20, default: () => "''" })
  timestamp: string;

  @OneToMany(() => ChapterWiseModel, (chapterWiseModel) => chapterWiseModel.chapter)
  chapterWiseModel: ChapterWiseModel[];

  @Column("bigint", { name: "chapter_parent_id" })
  chapterParentId: number;
}
